<template lang="pug">
span(v-if="hasEmail"): a(:href="hrefString") {{ label }}
span(v-else) {{ label }}
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'

const props = defineProps({
  email:    { type: String, default: '' },
  name:     { type: String, default: null },
  showName: { type: Boolean, default: false },
})

const hrefString = ref('')

const label = computed(() => {
  if (hasName.value && props.showName) {
    return props.name
  } else {
    return props.email
  }
})

const hasName = computed(() => {
  return !!props.name
})

const hasEmail = computed(() => {
  return !!props.email
})

onMounted(() => {
  if (hasName.value) {
    hrefString.value = `mailto:\"${props.name}\"<${props.email}>`  
  } else {
    hrefString.value = `mailto:${props.email}`
  }
})
</script>